<template>
    <v-app-bar app id="appbar" elevated color="blue-grey-lighten-1">
        <router-link to="/">
            <v-btn>
                <v-toolbar-title>Joking Heroes</v-toolbar-title>
            </v-btn>
        </router-link>

        <v-spacer></v-spacer>


        <div v-show="$vuetify.display.mobile">
            <v-btn
                href="mailto:&#105;&#110;&#102;&#111;&#064;&#106;&#111;&#107;&#105;&#110;&#103;&#104;&#101;&#114;&#111;&#101;&#115;&#046;&#100;&#101;?subject=Kontakt%20via%20JokingHeroes.de"
                class="navlink" prepend-icon="mdi-email-fast-outline" id="kontaktBtnMobile" variant="tonal" elevation="4">{{
                    mobileBtnText }}</v-btn>
            <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        </div>
        <div v-show="!$vuetify.display.mobile">
            <router-link :to="item.link" v-for="item in this.linkStore.navLinks" :key="item.id">
                <v-btn class="navlink" :id="item.id" variant="text">{{ item.title }}</v-btn>
            </router-link>
            <v-btn
                href="mailto:&#105;&#110;&#102;&#111;&#064;&#106;&#111;&#107;&#105;&#110;&#103;&#104;&#101;&#114;&#111;&#101;&#115;&#046;&#100;&#101;?subject=Kontakt%20via%20JokingHeroes.de"
                class="navlink" prepend-icon="mdi-email-fast-outline" id="kontaktBtn" variant="tonal"
                elevation="4">Kontakt</v-btn>
        </div>

    </v-app-bar>
    <v-navigation-drawer color="blue-grey-darken-2" v-model="drawer" location="left" temporary
        v-if="$vuetify.display.mobile">
        <li v-for="item in this.linkStore.navLinks" :key="item.id">
            <router-link :to="item.link">
                <v-btn class="navlink" :id="item.id" variant="text">{{ item.title }}</v-btn>
            </router-link>
        </li>
        <li v-for="item in this.linkStore.footerLinks" :key="item.id">
            <router-link :to="item.link">
                <v-btn class="navlink" :id="item.id" variant="text">{{ item.title }}</v-btn>
            </router-link>
        </li>
    </v-navigation-drawer>
</template>

<script>
import { useLinkStore } from "../store/links"

export default {
    setup() {
        const linkStore = useLinkStore();
        return { linkStore };
    },
    data: () => ({
        drawer: false,
    }),
    computed: {
        mobileBtnText() {
            return this.$vuetify.display.width <= 350 ? '' : 'Kontakt';
        }
    },

    watch: {
        useLinkStore
    },
}
</script>

<style>
a {
    text-decoration: none;
    color: #263238;
}

#kontaktBtn {
    margin-right: 30px !important;
}</style>
